import { ImmediateNurseConsultationVariant } from '@/hooks/useImmediateNurseConsultVariant';
import React, { createContext, useContext, useState } from 'react';

export type PreScreeningData = {
  patientDetails: {
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
    callType?: 'VOICE' | 'VIDEO';
  };
  smsVerification: {
    rateLimitIndex: number;
  };
  immediateNurseConsultation: {
    variant: ImmediateNurseConsultationVariant;
  };
};

type PreScreeningContextType = {
  preScreeningData: PreScreeningData;
  setPrescreeningData: React.Dispatch<React.SetStateAction<PreScreeningData>>;
};

const PreScreeningContext = createContext<PreScreeningContextType>({
  preScreeningData: {
    patientDetails: {
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      callType: undefined,
    },
    smsVerification: {
      rateLimitIndex: 0,
    },
    immediateNurseConsultation: {
      variant: ImmediateNurseConsultationVariant.CONTROL,
    },
  },
  setPrescreeningData: () => {},
});

export const PreScreeningContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [preScreeningData, setPrescreeningData] = useState<PreScreeningData>({
    patientDetails: {
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
    },
    smsVerification: {
      rateLimitIndex: 0,
    },
    immediateNurseConsultation: {
      variant: ImmediateNurseConsultationVariant.CONTROL,
    },
  });

  return (
    <PreScreeningContext.Provider value={{ preScreeningData, setPrescreeningData }}>
      {children}
    </PreScreeningContext.Provider>
  );
};

export const usePrescreeningData = () => {
  const context = useContext(PreScreeningContext);

  if (!context) {
    throw new Error('usePrescreeningData must be used within PrescreeningContext.Provider');
  }

  return context;
};
